import type { PhotoModel } from '@sosocio/creator-types/project';
import { MIME_TYPES_RASTER_IMAGES } from 'settings/filetypes';

/**
 * Determine whether transient design-print artwork has an immediately usable preview.
 *
 * Native picker URLs are preview sources supplied by the platform bridge and may
 * intentionally omit MIME metadata. Browser uploads instead rely on their parsed
 * MIME type and local-preview inspection result.
 *
 * @param photoModel Queued photo model to inspect.
 * @param isLocalPreviewUnusable Checks whether preview inspection rejected a local source.
 * @returns True when the design can be rendered before remote processing completes.
 */
export function canUseDesignPrintLocally(
	photoModel: PhotoModel,
	isLocalPreviewUnusable: (localRef: string) => boolean,
): boolean {
	if (!photoModel._vectorize?.isDesignPrint) {
		return false;
	}

	if (
		window.glPlatform === 'native'
		&& photoModel._localRef
		&& !photoModel._type
	) {
		return !isLocalPreviewUnusable(photoModel._localRef);
	}

	return Boolean(
		photoModel._type
		&& MIME_TYPES_RASTER_IMAGES.includes(photoModel._type)
		&& (
			!photoModel._localRef
			|| !isLocalPreviewUnusable(photoModel._localRef)
		),
	);
}
